import { mix } from '$ui/Flo/util';
import { Icon } from '$ui/Flo/Icon';
import * as React from 'react';
import styled from 'styled-components';
import { dates } from '$utils';

interface Props {
    endsAt: string;
}

export const SnoozeEndedWarning = (props: Props) => {
    const { endsAt } = props;

    return (
        <Container>
            <Icon icon="Moon" hue="white" opacity={1} size={2} />
            <Text>
                Snooze ended {dates.long(endsAt)} {dates.time(endsAt)}
            </Text>
        </Container>
    );
};

const Text = styled.span`
    margin-left: ${mix.unit({ size: 1 })};
    ${mix.type({ level: 'small' })};
`;

const Container = styled.div`
    background: var(--error-500);
    border-radius: 4px 4px 0 0;
    color: #FFFFFF;
    font-family: Roboto, serif;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    ${mix.padding({ padding: [0.5, 1.5] })};
    z-index: 10;
    position: relative;
    bottom: -1px;
`;
